import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./scss/index.scss";
import "slick-carousel/slick/slick.scss";
import React, { useState } from "react";
import ReactSVG from "react-svg";
import leftImg from "../../../../images/chevron_left.svg";
import rightImg from "../../../../images/chevron_right.svg";
export function ProductReviewsPopup(_ref) {
  var closeGallery = _ref.closeGallery,
      gallery = _ref.gallery,
      galleryIndex = _ref.galleryIndex;

  var _useState = useState(galleryIndex),
      _useState2 = _slicedToArray(_useState, 2),
      activeGalleryIndex = _useState2[0],
      setActiveGalleryIndex = _useState2[1];

  function nextSlide() {
    if (gallery && activeGalleryIndex + 1 < gallery.length) {
      setActiveGalleryIndex(activeGalleryIndex + 1);
    } else {
      setActiveGalleryIndex(0);
    }
  }

  function prevSlide() {
    if (gallery && activeGalleryIndex <= 0) {
      setActiveGalleryIndex(gallery.length - 1);
    } else {
      setActiveGalleryIndex(activeGalleryIndex - 1);
    }
  }

  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "slice-product-details__gallery popup"
  }, React.createElement("div", {
    className: "popup__container"
  }, React.createElement("div", {
    className: "popup__inner"
  }, React.createElement("button", {
    type: "button",
    onClick: closeGallery,
    className: "popup__close"
  }, "X"), React.createElement("img", {
    src: gallery ? gallery[activeGalleryIndex].url : "",
    alt: gallery ? gallery[activeGalleryIndex].url : ""
  }), React.createElement("div", {
    className: "slice-product-details__gallery-navigation"
  }, React.createElement("button", {
    type: "button",
    className: "slice-product-details__gallery-arrow arrow-left",
    onClick: prevSlide
  }, React.createElement(ReactSVG, {
    path: leftImg
  })), React.createElement("div", {
    className: "slice-product-details__gallery-counter"
  }, activeGalleryIndex + 1, "/", gallery && gallery.length), React.createElement("button", {
    type: "button",
    className: "slice-product-details__gallery-arrow arrow-right",
    onClick: nextSlide
  }, React.createElement(ReactSVG, {
    path: rightImg
  }))))), React.createElement("div", {
    className: "popup__bg"
  })));
}